import type { ScriptEntry } from './ironside-script-data';
import { emptyDraftFields, type DraftFields } from './ironside-script-fields';

export interface DraftOwner {
  creatorName?: string;
  creatorHandle?: string;
  brandSlug?: string;
  brandName?: string;
}

/** Shared row shape for a server-created week and a client-created video slot. */
export function buildScriptDraft(
  id: string, creatorEmail: string, week: number, videoNum: number,
  owner: DraftOwner, fields?: Partial<DraftFields>,
): ScriptEntry {
  return {
    id, creatorEmail, week, videoNum,
    creatorName: owner.creatorName ?? '', creatorHandle: owner.creatorHandle ?? '',
    brandSlug: owner.brandSlug ?? '', brandName: owner.brandName ?? '',
    grade: null, trafficLight: null, stage: 'to-be-submitted',
    lastGraded: null, daysSinceSubmission: null,
    brandNameProvided: owner.brandName ?? '',
    ...emptyDraftFields(), ...fields,
  };
}
